'use strict';

module.exports = footnote;

function footnote(node) {
  return '[^' + this.all(node).join('') + ']';
}



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-stringify/lib/visitors/footnote.js
// module id = 297
// module chunks = 96961042003272 139266963665775